import { TableChartConfigDto, PitchingStatsChartDto } from 'types/CodegenReportTypes';
import Table, { Order } from 'components/Table/Table';
import { getDisplayedColumns, tableHeaders } from 'utilities/tableHeaders';

import { ChartProps } from 'utilities/chartIdToComponent';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

export type PitchingStatsChartColumn = keyof PitchingStatsChartDto;

const PitchingStatsChart = ({ chartData, isLoading, extraChartData }: ChartProps<PitchingStatsChartDto, TableChartConfigDto>) => {
  const { t } = useTranslation();

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState<Order>('desc');
  const [orderBy, setOrderBy] = useState<PitchingStatsChartColumn | '' | 'id'>('');

  const rows = useMemo(
    () =>
      chartData?.games
        ? [
            {
              ...chartData,
              id: chartData.chartId,
            },
          ]
        : [],
    [chartData]
  );

  const columns = useMemo(() => {
    const displayedColumns = getDisplayedColumns<PitchingStatsChartColumn>(extraChartData.visibleStats);

    return displayedColumns.map((column) => ({
      ...tableHeaders[column],
      field: column,
      headerName: t(column),
      headerShortName: t('short.' + column),
      sortable: true,
    }));
  }, [extraChartData.visibleStats]);

  return (
    <Table
      rows={rows}
      pageState={[page, setPage]}
      orderState={[order, setOrder]}
      orderByState={[orderBy, setOrderBy]}
      columns={columns}
      loading={isLoading}
      noFooter
      tileTable
      skeletonRows={1}
    />
  );
};

export default PitchingStatsChart;
